import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { Navigate } from 'react-router';
import FullPageLoader from '~/components/FullPageLoader/FullPageLoader';
import { commonStyles } from '~/modules/covenants/CovenantsDataForm/commonStyles.ts';
import { guaranteesClientPageStyles } from '~/modules/guarantees/form/client/styles.ts';
import ApplicationHeader from '../../shared/components/ApplicationHeader.tsx';
import ApplicationPageFrame from '../../shared/components/ApplicationPageFrame.tsx';
import GuaranteesManagerApplicationSidePanelLayout from '../shared/SidePanel/GuaranteesManagerApplicationSidePanelLayout.tsx';
import UakdoControllerControlSection from './UakdoControllerControlSection.tsx';
import { useUakdoControllerControlPage } from './useUakdoControllerControlPage.ts';

const UakdoControllerControlPage: React.FC = () => {
  const {
    modalAlert,
    modalSuccess,
    handleCloseAlertModal,
    handleCloseSuccessModal,
    handleCloseUakdoAccessModal,
    handleConfirm,
    handleReject,
    headerProps,
    isApplicationLoading,
    isExecutionFormLoading,
    isRejectingByUakdoController,
    isSubmittingByUakdoController,
    isUakdoAccessDenied,
    isUakdoAccessLoading,
    isUakdoControllerControlEditable,
    redirectPath,
    securityType,
    currentApplicationVersion,
    effectiveApplicationId,
    executionForm,
    showGuaranteesRequestError,
  } = useUakdoControllerControlPage();

  if (redirectPath) {
    return <Navigate to={redirectPath} replace />;
  }

  if (isUakdoAccessLoading) {
    return <FullPageLoader />;
  }

  return (
    <ApplicationPageFrame
      modalAlert={modalAlert}
      modalSuccess={modalSuccess}
      onModalClose={isUakdoAccessDenied ? handleCloseUakdoAccessModal : handleCloseAlertModal}
      onSuccessModalClose={handleCloseSuccessModal}
    >
      <ApplicationHeader {...headerProps} />

      {isUakdoAccessDenied ? null : isApplicationLoading ? (
        <Box sx={commonStyles.centeredLoader}>
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={guaranteesClientPageStyles.applicationFlowStack}>
          <GuaranteesManagerApplicationSidePanelLayout
            applicationId={effectiveApplicationId}
            onError={showGuaranteesRequestError}
          >
            <UakdoControllerControlSection
              executionForm={executionForm}
              isConfirming={isSubmittingByUakdoController}
              isDisabled={!currentApplicationVersion || !isUakdoControllerControlEditable}
              isLoading={isExecutionFormLoading}
              isRejecting={isRejectingByUakdoController}
              securityType={securityType}
              onConfirm={handleConfirm}
              onReject={handleReject}
            />
          </GuaranteesManagerApplicationSidePanelLayout>
        </Box>
      )}
    </ApplicationPageFrame>
  );
};

export default UakdoControllerControlPage;
